import { render } from "./PropertyCustomerDetails.vue?vue&type=template&id=83a8d810&ts=true"
import script from "./PropertyCustomerDetails.vue?vue&type=script&lang=ts"
export * from "./PropertyCustomerDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__